module.exports = __webpack_public_path__ + "static/media/FleetLocate_LoginBanners.81c91f71.jpg";